// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".truncate-overflow[data-v-693a3fdc]{--max-lines:5;position:relative;max-height:calc(1.5rem*var(--max-lines));overflow:hidden}.truncate-overflow[data-v-693a3fdc]:before{content:\"[...]\";position:absolute;bottom:0;right:0;padding-left:.5rem;--bg-opacity:1;background-color:#faf5f2;background-color:rgba(250,245,242,var(--bg-opacity));--text-opacity:1;color:#989898;color:rgba(152,152,152,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
